import React from 'react'
import cx from 'classnames'
import { isEmpty } from 'lodash'
import GalleryToggle from './GalleryToggle'
import DefaultImage from '../../../../assets/images/product/default-image-product.png'

class ProductCardGallery extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      activeItem: 0
    }
  }

  rotateRight() {
    let n = this.props.photos.length
    this.setState({
      activeItem: (((this.state.activeItem + 1) % n) + n) % n
    })
  }

  rotateLeft() {
    let n = this.props.photos.length
    this.setState({
      activeItem: (((this.state.activeItem - 1) % n) + n) % n
    })
  }

  render() {
    const {
      photos
    } = this.props
    return (
      <div className="product-card-gallery">
        { 
          !isEmpty(photos) && (
            <GalleryToggle
              icon='<'
              action={this.rotateLeft.bind(this)}
              left
            />
          )
        }
        {
          !isEmpty(photos) && photos.map((photo, i) => {
            return (
              <div
                key={i}
                className={cx('gallery-item', { 'active': this.state.activeItem === i })}
                style={{
                  backgroundImage: `url(${photo})`,
                  cursor: this.props.imageClick ? 'pointer' : ''
                }}
                onClick={this.props.imageClick}
              />
            )
          })
        }
        {
          isEmpty(photos) && (
            <div
              className={cx('gallery-item active')}
              style={{
                backgroundImage: `url(${DefaultImage})`
              }}
            />
          )
        }
        {
          !isEmpty(photos) && (
            <GalleryToggle
              icon='>'
              action={this.rotateRight.bind(this)}
              right
            />
          )
        }
      </div>
    )
  }
}

export default ProductCardGallery
